module.exports = __webpack_public_path__ + "static/media/font-awesome.15cb7faa.less";